import { ALTERNATE_RX_PRODUCT_VALUE } from '../constants/product.constant';

export const hasAlternateRx = ({ products = [] }) => {
  let hasAlternateRx = false;
  for (let i = 0; i < products.length; i++) {
    const _product = products[i] || { ProductId: 0 };
    if (_product.ProductId === ALTERNATE_RX_PRODUCT_VALUE) {
      hasAlternateRx = true;
      break;
    }
  }
  return hasAlternateRx;
};
